export default class Accordion {
    constructor()
    {
        this.container = document.querySelector('.cp-hp-toggle-tabs');
        if (!this.container) {
            return;
        }

        this.toggleTabs = document.querySelectorAll('.js-toggle-tab');
        this.toggleAccordions = document.querySelectorAll('.js-toggle-accordion');

        [...this.toggleTabs].forEach((el) => {
            el.addEventListener('click', (evt) => {
                this.toggleTab(evt);
                let tab = event.currentTarget.getAttribute('data-tab');
                this.changeActive(tab);
            });
            
        });

        [...this.toggleAccordions].forEach((el) => {
            el.addEventListener('click', (evt) => {
                this.toggleAccordion(evt);
             });
        });
    }

    toggleTab(evt)
    {
        let item = evt.currentTarget;
        if (item.classList.contains('-active')) {
            return item.classList.remove('-active');
        }

        this.deselectTabs();
        item.classList.add('-active');
    }

    changeActive(tab) {
        let current = this.container.parentNode.querySelector('.tab-content.-active');
        current.classList.remove('-active');

        let newActive = this.container.parentNode.querySelector('.tab-' + tab);
        newActive.classList.add('-active');
    }

    deselectTabs()
    {
        let items = this.container.querySelectorAll('.tab-item');
        [...items].forEach((el) => {
            el.classList.remove('-active')
        });
    }

    toggleAccordion(evt)
    {
        let parent = evt.currentTarget.parentNode;
        if (parent.classList.contains('-open')) {
            return parent.classList.remove('-open');
        }

        this.deselectAccordions();
        parent.classList.add('-open');
    }

    deselectAccordions()
    {
        let items = this.container.querySelectorAll('.item');
        [...items].forEach((el) => {
            el.classList.remove('-open')
        });
    }
}